export default "__VITE_ASSET__DvhUj4v6__"